import LoaderPage from 'components/ui/feedback/LoaderPage'
import { lazy } from 'react'
import { Route, RouteProps, Routes } from 'react-router-dom'

const ProfilePage = lazy(() => import('pages/profile/page'))

const ProfileRoutes: React.FunctionComponent<RouteProps> = () => {
  return (
    <Routes>
      <Route path="/" element={<LoaderPage content={<ProfilePage />} />} />
    </Routes>
  )
}

export default ProfileRoutes
